import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';
import { createNumberTracker, listGeneralSetting, listUsedVoucherSerialNumbers, listVoucherSerialNumbers } from '../../graphql';

export const voucherSettingsApi = createApi({
    reducerPath: 'voucherSettingsApi',
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        listGeneralSetting: builder.query({
            query: (variables) => ({ body: listGeneralSetting, variables }),
            keepUnusedDataFor: Infinity,
            refetchOnMountOrArgChange: true,
            providesTags: ['listGeneralSettings'],
        }),
        listUsedVoucherSerialNumbers: builder.query({
            query: (variables) => ({ body: listUsedVoucherSerialNumbers, variables }),
            keepUnusedDataFor: Infinity,
            refetchOnMountOrArgChange: true,
            providesTags: ['listUsedVoucherSettings'],
        }),
        listVoucherSerialNumbers: builder.query({
            query: (variables) => ({ body: listVoucherSerialNumbers, variables }),
            keepUnusedDataFor: Infinity,
            refetchOnMountOrArgChange: true,
            providesTags: (result, error, { entrytypecd }) => [
                { type: "listVoucherSettings", id: entrytypecd },
                { type: "VoucherSerialNumbers", id: "ALL" },
            ],
        }),
        createNumberTracker: builder.mutation({
            query: (variables) => ({ body: createNumberTracker, variables }),
            invalidatesTags: (result, error, { entrytypecd }) => [
                { type: "listVoucherSettings", id: entrytypecd },
            ],
        }),

    }),
});

export const { useListGeneralSettingQuery, useListUsedVoucherSerialNumbersQuery, useListVoucherSerialNumbersQuery, useCreateNumberTrackerMutation } = voucherSettingsApi;
